import { render, staticRenderFns } from "./customer-order-statistic.vue?vue&type=template&id=a3256a5e&scoped=true"
import script from "./customer-order-statistic.vue?vue&type=script&lang=ts"
export * from "./customer-order-statistic.vue?vue&type=script&lang=ts"
import style0 from "./customer-order-statistic.vue?vue&type=style&index=0&id=a3256a5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3256a5e",
  null
  
)

export default component.exports